import axios from "axios";
import { APIConfig } from "./api-config";
import store from "./../store/index";
import { CommonClass } from "@/mixins";
import { util } from "@/helpers";
import router, { urlContants } from "@/router/index";
import { ERROR_CODES } from "@/utils/constants";
import sessionStorageUtils from "@/utils/session-storage";

//create an axios instance
const service = axios.create(APIConfig);
/* eslint-disable */
const csrfToken = document.cookie.replace(
  /(?:(?:^|.*;\s*)XSRF-TOKEN\s*\=\s*([^;]*).*$)|^.*$/,
  "$1"
);

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something here before reqest is sent

    if (csrfToken) {
      // let each reqest carry token here
      config.headers["X-XSRF-TOKEN"] = csrfToken;
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// // response interceptor
service.interceptors.response.use(
  function (response) {
    const respData = CommonClass.methods.$__processDecryptResponse(response.data, process.env.VUE_APP_ENCODEKEY);
    if (
      respData?.successFlag === false &&
      respData?.errCode === ERROR_CODES.MIDERR_020
    ) {
      router.replace(
        `${urlContants.loginUrl}/my-info?errCode=${ERROR_CODES.MIDERR_020}&optionAllowed=true`
      );
    }
    return response;
  },
  function (e) {
    const respData = CommonClass.methods.$__processDecryptResponse(e.response.data, process.env.VUE_APP_ENCODEKEY);
    const errCode = respData?.errCode || e?.response?.status;
    const errMsg = util.getUiErrorByCode(errCode);
    if (errCode === "MIDERR_041") {
      router.push("/login");
      store.commit(
        "alert/SHOW_ALERT",
        {
          message: errMsg,
          type: "error",
        },
        { root: true }
      );
      sessionStorageUtils.deleteItem("requestID");
      sessionStorageUtils.deleteItem("loggedIn");
    }
    return Promise.reject(e);
  }
);

export default service;
